import { render, staticRenderFns } from "./about-swiper-it.vue?vue&type=template&id=e40aff68"
import script from "./about-swiper-it.vue?vue&type=script&lang=js"
export * from "./about-swiper-it.vue?vue&type=script&lang=js"
import style0 from "./about-swiper-it.vue?vue&type=style&index=0&id=e40aff68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports